import { legacyTabToPath } from "@/lib/portal-nav";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/dashboard")({
  validateSearch: (search: Record<string, unknown>) => ({
    licenseId: (search.licenseId as string) || undefined,
    tab: (search.tab as string) || undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.tab === "attom-tax-assessor-status") {
      throw redirect({
        to: "/operator/setup",
        search: { tab: "attom-status", partiesTab: "parties" },
        replace: true,
      });
    }
    const to = legacyTabToPath("operator", search.tab as string | undefined);
    const nextSearch: Record<string, unknown> = {};
    if (to.includes("/registrations") && search.licenseId) {
      nextSearch.licenseId = search.licenseId;
    }
    throw redirect({ to, search: nextSearch, replace: true });
  },
  component: () => null,
});
